import {money,precise} from "./DecimalCell";

export const pct=v=>v==null?"—":`${precise(v,2)} %`;
export const industrialFormula=(ovPct,direct,industrial)=>direct!=null&&industrial!=null?`${money(direct)} × (1 + ${pct(ovPct)}) = ${money(industrial)}`:`costi diretti × (1 + ${pct(ovPct)})`;
export const sellingFormula=(policy,industrial,selling)=>{
  const markup=policy?.method==="MARKUP_ON_COST",op=markup?`× (1 + ${pct(policy?.pct)})`:`÷ (1 − ${pct(policy?.pct)})`;
  return industrial!=null&&selling!=null?`${money(industrial)} ${op} = ${money(selling)}`:`costo industriale ${op}`;
};
export const missingOperations=components=>components.flatMap(c=>(c.rows||[]).filter(r=>r.unit_eur_raw==null&&!r.excluded_from_estimate&&!["overhead","margin"].includes(r.key)).map(r=>({component_code:c.component_code,key:r.key,label:(r.label||r.key).split(" (")[0]})));
